
import { useAppStore } from '@/store/app'
import Vue from 'vue'
import DocumentsPreviewItem from './request-signature/documents-preview-item.vue'

export default Vue.extend({
  name: 'TemplateLookup',
  props: {
    rules: {
      type: Array,
      required: false
    }
  },
  setup () {
    const app = useAppStore()

    return {
      app
    }
  },
  data () {
    return {
      templates: new Array<any>(),
      value: new Array<any>(),
      checked: true
    }
  },
  async mounted () {
    this.fetch()
    this.emitInterface()
  },
  methods: {
    filterData (item: any, queryText: string) {
      return (
        item.name.toLowerCase().includes(queryText.toLowerCase()) ||
        item.id.toLowerCase().includes(queryText.toLowerCase())
      )
    },
    changeValue (value: any) {
      this.$emit('changed', value ?? [])
    },
    remove (item: { name: string; }) {
      this.templates = []
      /*
        const index = this.friends.indexOf(item.name)
        if (index >= 0) this.friends.splice(index, 1)
      */
    },
    clear () {
      this.value = []
    },
    isSelected (item: any) {
      return this.value.includes(item)
    },
    toggleItem (item: any) {
      this.checked = true
      if (this.value.includes(item)) {
        this.value = this.value.filter(v => v !== item)
      } else {
        this.value.push(item)
      }

      this.changeValue(this.value)
    },
    async fetch () {
      const user = this.app.selectedClient?.id ?? ''
      const res = await fetch(`${process.env.VUE_APP_API_URL}/${user}/templates`)
      const data = await res.json()
      const normalize = (text: string) => text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      const templates = Object.keys(data).map(id => data[id])
        .sort((r1: {name: string}, r2: {name: string}) => (normalize(r1.name) < normalize(r2.name)) ? -1 : (normalize(r1.name) > normalize(r2.name)) ? 1 : 0)

      this.templates = templates
    },
    /**
     * Emitting an interface with callable methods from outside
     */
    emitInterface () {
      this.$emit('interface', {
        clear: () => this.clear(),
        refetch: async () => this.fetch()
      })
    }
  }
})
